import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createRoom } from '../services/roomService';
import '../styles/CreateRoom.css';

const CreateRoom = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleCreateRoom = async () => {
    setLoading(true);
    setError(null);

    try {
      const roomCode = await createRoom(
        user.uid,
        user.displayName,
        user.photoURL
      );

      // Navigate to the room lobby
      navigate(`/room/${roomCode}`);
    } catch (err) {
      console.error('Failed to create room:', err);
      setError(err.message || 'Failed to create room. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="create-room-container">
      <div className="create-room-card">
        <h2>Create a Game Room</h2>
        <p className="create-room-description">
          Create a private room and invite a friend to play!
        </p>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <button
          className="create-room-button"
          onClick={handleCreateRoom}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner"></span>
              Creating Room...
            </>
          ) : (
            <>
              <span className="icon">🎮</span>
              Create Room
            </>
          )}
        </button>

        <button
          className="back-button"
          onClick={() => navigate('/profile')}
          disabled={loading}
        >
          Back to Profile
        </button>
      </div>
    </div>
  );
};

export default CreateRoom;
